export const TagUsageCalculations = {
  calculateRemaining: (weight: number, consumedGrams: number): number => {
    return Number(weight) - Number(consumedGrams);
  },

  calculatePercentage: (weight: number, consumedGrams: number): number => {
    return (Number(consumedGrams) / Number(weight)) * 100;
  },

  formatRemaining: (weight: number, consumedGrams: number): string => {
    if (!weight) return '-';
    const remaining = TagUsageCalculations.calculateRemaining(weight, consumedGrams);
    return `${remaining.toFixed(2)} g`;
  },

  formatPercentage: (weight: number, consumedGrams: number): string => {
    if (!weight) return '-';
    const percentage = TagUsageCalculations.calculatePercentage(weight, consumedGrams);
    return `${percentage.toFixed(1)}%`;
  },

  getRemainingColor: (weight: number, consumedGrams: number): string => {
    const remaining = TagUsageCalculations.calculateRemaining(weight, consumedGrams);
    return remaining < 100 ? 'red' : 'inherit';
  },

  getPercentageColor: (weight: number, consumedGrams: number): string => {
    const percentage = TagUsageCalculations.calculatePercentage(weight, consumedGrams);
    return percentage > 80 ? 'orange' : 'inherit';
  },
};
